export default __webpack_public_path__ + "static/morningfresh-c17bc8730b3573223fb74dcf3a285f62.png";